const LOCAL_HOST = "lvh.me:3000";

// "Paste backend PR_LINK here and comment &&_null for testing"
const PR_LINK = "PR_LINK" && null;
const PRODUCTION_HOST =
  PR_LINK || process.env.REACT_APP_API_HOST || "https://node-planner.com/";

export const domain = PRODUCTION_HOST
  ? `https://${PRODUCTION_HOST}`
  : `http://${LOCAL_HOST}`;

export const API_WS_ROOT = PRODUCTION_HOST
  ? `wss://${PRODUCTION_HOST}/cable`
  : `ws://${LOCAL_HOST}/cable`;

export const API_URLS = {
  LOGIN: `${domain}/users/sign_in`,
  RESET_PASSWORD: `${domain}/users/password/reset`,
  FORGOT_PASSWORD: `${domain}/users/password/forgot`,
};

export const COMMON_API_URLS = {
  UPDATE_NOTIFICATION_STATUS: `${domain}/api/admin/notifications`,
  GET_NOTIFICATIONS: `${domain}/api/admin/notifications`,
  UPDATE_REQUEST: `${domain}/api/admin/requests/update`,
  GET_NODES_TREE: (view_level) =>
    `${domain}/api/admin/${view_level}/nodes_view`,
  GET_DASHBOARD_DATA: `${domain}/api/admin/dashboard`,
  GET_NODES_TREE2: `${domain}/api/admin/ministries/nodes_view`,
};

export const ADMIN_API_ULRS = {
  GET_DASHBOARD_DATA: `${domain}/api/admin/dashboard`,
  CREATE_MINISTRY: `${domain}/api/admin/ministries/create`,
  UPDATE_MINISTRY: `${domain}/api/admin/ministries/update`,
  GET_ALL_MINISTRIES: `${domain}/api/admin/ministries/index`,

  //states

  GET_ALL_PROVINCE: `${domain}/api/admin/states/index`,

  //batches

  GET_ALL_BATCHES: `${domain}/api/admin/batches/index`,

  //user

  UPDATE_PASSWORD: `${domain}/users/update_password`,
  UPDATE_USER: `${domain}/users/update_user`,

  //Categores

  GET_ALL_CATEGORIES: `${domain}/api/admin/categories/index`,
  CREATE_CATEGORY: `${domain}/api/admin/categories/create`,
  UPDATE_CATEGORY: `${domain}/api/admin/categories/update`,

  //products

  GET_ALL_PRODUCTS: `${domain}/api/admin/products/index`,
  CREATE_PRODUCT: `${domain}/api/admin/products/create`,
  UPDATE_PRODUCT: `${domain}/api/admin/products/update`,
  UPDATE_NOTIFICATION_STATUS: `${domain}/api/admin/notifications`,
};

export const MINISTRY_API_ULRS = {
  GET_DASHBOARD_DATA: `${domain}/api/admin/dashboard`,
  CREATE_PROVINCE: `${domain}/api/admin/states/create`,
  UPDATE_PROVINCE: `${domain}/api/admin/states/update`,
  UPDATE_USERS: `${domain}/users/update_user`,

  GET_ALL_PROVINCE: `${domain}/api/admin/states/index`,
  GET_ALL_BATCHES: `${domain}/api/admin/batches/index`,
  CREATE_BATCH: `${domain}/api/admin/batches/create`,
  ISSUE_BATCH: `${domain}/api/admin/batches/issue_batch`,
  TRANSFER_BATCH: `${domain}/api/admin/batches/transfer_batch`,
  UPDATE_PASSWORD: `${domain}/users/update_password`,
  REQUEST_INVENTORY: `${domain}/api/admin/requests/return_receiver`,
  REQUEST_BATCH_LISTINGS: `${domain}/api/admin/batches/batch_listing`,
  GET_ALL_REQUESTS: `${domain}/api/admin/requests/index`,
  CREATE_REQUEST: `${domain}/api/admin/requests/create`,
  UPDATE_REQUEST: `${domain}/api/admin/requests/update`,
  APPROVE_REQUEST: `${domain}/api/admin/batches/request_approved`,
  RECEIVE_INVENTORY: `${domain}//api/admin/batches/batch_received`,
  RETIRE_BATCH: `${domain}/api/admin/transactions/retire_transaction`,
  UPDATE_USER: `${domain}/users/update_user`,
  GET_TEMPERATURE: `${domain}/api/admin/batches/pfizer_temperature`,
  UPLOAD_NODES_FILE: `${domain}/api/admin/ministries/create_nodes`,
  UPDATE_NOTIFICATION_STATUS: `${domain}/api/admin/notifications`,
};

export const PROVINCE_API_ULRS = {
  GET_DASHBOARD_DATA: `${domain}/api/admin/dashboard`,
  CREATE_DISTRICT: `${domain}/api/admin/districts/create`,
  UPDATE_DISTRICT: `${domain}/api/admin/districts/update`,
  GET_ALL_DISTRICT: `${domain}/api/admin/districts/index`,
  GET_ALL_PROVINCE: `${domain}/api/admin/states/index`,
  GET_ALL_BATCHES: `${domain}/api/admin/batches/index`,
  ISSUE_BATCH: `${domain}/api/admin/batches/issue_batch`,
  TRANSFER_BATCH: `${domain}/api/admin/batches/transfer_batch`,
  UPDATE_PASSWORD: `${domain}/users/update_password`,
  REQUEST_INVENTORY: `${domain}/api/admin/requests/return_receiver`,
  CREATE_REQUEST: `${domain}/api/admin/requests/create`,
  RETIRE_BATCH: `${domain}/api/admin/transactions/retire_transaction`,
  UPDATE_USER: `${domain}/users/update_user`,
  GET_ALL_REQUESTS: `${domain}/api/admin/requests/index`,
  UPDATE_REQUEST: `${domain}/api/admin/requests/update`,
  UPDATE_NOTIFICATION_STATUS: `${domain}/api/admin/notifications`,
};

export const DISTRICTS_API_ULRS = {
  GET_DASHBOARD_DATA: `${domain}/api/admin/dashboard`,
  CREATE_POU: `${domain}/api/admin/hospitals/create`,
  UPDATE_POU: `${domain}/api/admin/hospitals/update`,
  GET_ALL_POU: `${domain}/api/admin/hospitals/index`,
  GET_ALL_PROVINCE: `${domain}/api/admin/states/index`,
  GET_ALL_BATCHES: `${domain}/api/admin/batches/index`,
  ISSUE_BATCH: `${domain}/api/admin/batches/issue_batch`,
  TRANSFER_BATCH: `${domain}/api/admin/batches/transfer_batch`,
  UPDATE_PASSWORD: `${domain}/users/update_password`,
  RETIRE_BATCH: `${domain}/api/admin/transactions/retire_transaction`,
  UPDATE_USER: `${domain}/users/update_user`,
  GET_ALL_REQUESTS: `${domain}/api/admin/requests/index`,
  UPDATE_NOTIFICATION_STATUS: `${domain}/api/admin/notifications`,
};

export const POU_API_ULRS = {
  GET_DASHBOARD_DATA: `${domain}/api/admin/dashboard`,
  GET_ALL_PROVINCE: `${domain}/api/admin/states/index`,
  GET_ALL_BATCHES: `${domain}/api/admin/batches/index`,
  GET_ALL_POU: `${domain}/api/admin/hospitals/index`,
  ISSUE_BATCH: `${domain}/api/admin/batches/issue_batch`,
  TRANSFER_BATCH: `${domain}/api/admin/batches/transfer_batch`,
  UPDATE_PASSWORD: `${domain}/users/update_password`,
  RETIRE_BATCH: `${domain}/api/admin/transactions/retire_transaction`,
  UPDATE_USER: `${domain}/users/update_user`,
  GET_ALL_REQUESTS: `${domain}/api/admin/requests/index`,
  UPDATE_NOTIFICATION_STATUS: `${domain}/api/admin/notifications`,
};
